module.exports = __webpack_public_path__ + "static/media/teaching-learning.730860f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/reportcentre/teaching-learning.jpg
// module id = 2939
// module chunks = 0